export const { BASE_URL } = process.env

export const routes = {
  login: {
    path: '/',
    makeUrl: () => `/`,
    exampleParams: {},
  },
  userInvite: {
    path: '/portal/user-invite',
    makeUrl: () => `/portal/user-invite`,
    exampleParams: {},
  },
  forgotPassword: {
    path: '/portal/forgot-password',
    makeUrl: () => `/portal/forgot-password`,
    exampleParams: {},
  },
  resetPassword: {
    path: '/portal/reset-password',
    makeUrl: () => `/portal/reset-password`,
    exampleParams: {},
  },
  dashboard: {
    path: '/portal',
    makeUrl: () => `/portal`,
    exampleParams: {},
  },
  quotation: {
    path: '/portal/quotation/:quotationId',
    makeUrl: (quotationId: number) => `/portal/quotation/${quotationId}`,
    exampleParams: {
      quotationId: '34',
    },
  },
  profile: {
    path: '/portal/profile',
    makeUrl: () => `/portal/profile`,
    exampleParams: {},
  },
  editProfile: {
    path: '/portal/profile/edit',
    makeUrl: () => `/portal/profile/edit`,
    exampleParams: {},
  },
}

type Routes = typeof routes
type RoutesKeys = keyof Routes

export const matchAppRoute = (pathname: string) => {
  const matchedKey = Object.keys(routes).find(
    r => routes[r as RoutesKeys].path === pathname
  ) as RoutesKeys
  return routes[matchedKey]
}
